import React from 'react';

import clsx from 'clsx';

import styles from '@/components/LoaderIcon.module.css';

const LoaderIcon = ({
  className,
  xmlns,
  width,
  height,
  fill,
  viewBox,
}: React.SVGProps<SVGSVGElement> & { title?: string }) => (
  <svg
    className={clsx(className, 'm-auto h-full lg:h-[300px]')}
    xmlns={xmlns || 'http://www.w3.org/2000/svg'}
    width={width || '300'}
    height={height || '300'}
    fill={fill || 'none'}
    viewBox={viewBox || '0 0 300 300'}
  >
    <g>
      <g>
        <circle className={styles.loaderSun} cx="198.5" cy="123.102" r="25.5" fill="#FFEC88" />
        <path
          className={styles.loaderSunRays}
          fill="#FFEC88"
          d="M191.017 56.016a3 3 0 00-2.674 3.295l3.105 29.839a3 3 0 005.968-.621l-3.105-29.84a3 3 0 00-3.294-2.673zM201.263 154.485a3 3 0 00-2.674 3.294l3.105 29.839a3 3 0 005.968-.621l-3.105-29.839a2.999 2.999 0 00-3.294-2.673zM234.068 121.915a3 3 0 01-.621-5.968l29.839-3.105a3 3 0 01.621 5.968l-29.839 3.105zM130.316 129.694a3.001 3.001 0 003.294 2.674l29.839-3.105a3 3 0 00-.621-5.968L132.99 126.4a3 3 0 00-2.674 3.294zM154.805 93.328a3 3 0 013.781-4.659l13.977 11.343a3 3 0 01-3.781 4.659l-13.977-11.343zM237.098 82.51a3 3 0 01.439 4.22l-11.342 13.977a3 3 0 11-4.659-3.78l11.342-13.977a3 3 0 014.22-.44zM222.846 148.167a3 3 0 013.781-4.659l13.977 11.342a3 3 0 01-3.781 4.659l-13.977-11.342zM177.707 147.593a3 3 0 01.439 4.22l-11.342 13.976a3 3 0 11-4.659-3.78l11.342-13.977a3 3 0 014.22-.439z"
        />
        <path
          fill="#DAD1FF"
          d="M193.681 192.908c.723.061 1.454.092 2.193.092C210.303 193 222 181.196 222 166.636s-11.697-26.363-26.126-26.363a26.01 26.01 0 00-6.051.71C185.899 121.037 168.46 106 147.541 106c-18.284 0-33.909 11.486-40.176 27.698a28.574 28.574 0 00-.973-.016C90.159 133.682 77 146.961 77 163.341c0 15.444 11.698 28.13 26.64 29.531.795.084 1.604.128 2.422.128h85.57c.69 0 1.375-.031 2.049-.092z"
        />
        <ellipse className={styles.loaderCloudBlush} cx="170.517" cy="160.255" fill="#FBA0E7" rx="8.502" ry="2.498" />
        <ellipse className={styles.loaderCloudBlush} cx="129.51" cy="160.255" fill="#FBA0E7" rx="8.502" ry="2.498" />
        <g fill="#303030">
          <path
            className={styles.loaderCloudMouthSmile}
            d="M141.988 166.812c-.612 0-1.095-.515-.968-1.097.863-3.945 4.108-6.878 7.98-6.878 3.872 0 7.117 2.933 7.98 6.878.127.582-.356 1.097-.968 1.097-.525 0-.959-.383-1.08-.879-.745-3.065-3.267-5.102-5.932-5.102-2.665 0-5.187 2.037-5.932 5.102-.121.496-.555.879-1.08.879z"
          />
          <path
            className={styles.loaderCloudMouthSad}
            d="M150.668 157.259c-.575.21-1.206-.111-1.286-.703-.545-4.013 1.497-7.888 5.134-9.214 3.638-1.326 7.694.327 9.86 3.749.319.505.043 1.156-.532 1.366-.493.179-1.033-.033-1.317-.46-1.752-2.633-3.023 1.193-5.527 2.105-2.504.913-5.973-1.185-5.62 1.958.057.509-.219 1.02-.712 1.199z"
          />
          <path
            className={styles.loaderCloudRightEye}
            d="M165 154.849c0-1.101.895-1.994 2-1.994s2 .893 2 1.994v1.994a1.997 1.997 0 01-2 1.994c-1.105 0-2-.893-2-1.994v-1.994z"
          />
          <path
            className={styles.loaderCloudLeftEye}
            d="M129 154.849c0-1.101.895-1.994 2-1.994s2 .893 2 1.994v1.994a1.997 1.997 0 01-2 1.994c-1.105 0-2-.893-2-1.994v-1.994z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default LoaderIcon;
